var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.411,
    height: 22.468,
    viewBox: "0 0 22.411 22.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.121)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.121)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.293,34.632l9.264-5.349a.469.469,0,0,0,0-.813l-9.264-5.35a.47.47,0,0,0-.7.407v2.491h-8a.47.47,0,0,0-.47.47v4.778a.47.47,0,0,0,.47.47h8v2.49a.47.47,0,0,0,.7.407Z",
    transform: "translate(-0.121 -17.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M48.066,0H38.5a.47.47,0,0,0-.47.47V1.879a.47.47,0,0,0,.47.47h9.57a1.122,1.122,0,0,1,1.12,1.12V19a1.122,1.122,0,0,1-1.12,1.12H38.5a.47.47,0,0,0-.47.47V22a.47.47,0,0,0,.47.47h9.57A3.473,3.473,0,0,0,51.535,19V3.469A3.473,3.473,0,0,0,48.066,0Z",
    transform: "translate(-29.124)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/loginIcon.9a6c87a18a668b0f872d0133a1e8b702.svg";
export { ForwardRef as ReactComponent };